export function buildV2TranscriptRows(transcripts, formatTimeInMinute) {
  if (!Array.isArray(transcripts) || transcripts.length === 0) {
    return [];
  }

  const sortedTranscripts = [...transcripts].sort((a, b) => {
    const startA = Number(a.start) || 0;
    const startB = Number(b.start) || 0;
    return startA - startB;
  });

  return sortedTranscripts.map((segment) => {
    const startSeconds = Number(segment.start) || 0;
    const endSeconds = Number(segment.end) || 0;
    const sentenceId =
      segment.sentence_id ??
      (segment.id !== undefined && segment.id !== null ? segment.id : null);

    return {
      ...segment,
      sentence_id:
        sentenceId === null || sentenceId === undefined
          ? null
          : Number(sentenceId),
      start: formatTimeInMinute(startSeconds),
      end: formatTimeInMinute(endSeconds),
    };
  });
}

function normaliseUserId(value) {
  if (value === null || value === undefined) {
    return null;
  }
  const numeric = Number(value);
  if (!Number.isNaN(numeric)) {
    return numeric;
  }
  return String(value);
}

export function shouldHighlightSegment(
  segment,
  problematicSentenceSet,
  targetUserId
) {
  if (
    !segment ||
    !problematicSentenceSet ||
    typeof problematicSentenceSet.has !== "function" ||
    targetUserId === null ||
    targetUserId === undefined
  ) {
    return false;
  }

  const sentenceIdentifier =
    segment.sentence_id ??
    (segment.id !== undefined && segment.id !== null ? segment.id : null);

  const numericSentenceId = Number(sentenceIdentifier);
  if (Number.isNaN(numericSentenceId)) {
    return false;
  }

  if (!problematicSentenceSet.has(numericSentenceId)) {
    return false;
  }

  const target = normaliseUserId(targetUserId);
  const segmentUser = normaliseUserId(segment.user_id);

  if (target === null || segmentUser === null) {
    return false;
  }

  return target === segmentUser;
}

export function normaliseReportReasonKey(value) {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    return value.trim();
  }

  return String(value);
}
